// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3sLEo","amount":"Amount_amount__mtS21","tip":"Amount_tip__2pGbZ","tipHeader":"Amount_tipHeader__23QSq","tipsWrap":"Amount_tipsWrap__2yZGI"};